import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {LineupsMemberYardFormationApiModel} from "./lineups-member-yard-formation-api-model";

export class LineupsMemberYardFormationDomainModel extends BaseDomainModel {
  apiModel: LineupsMemberYardFormationApiModel;

  get line(): Number {
    return this.apiModel.line;
  }

  get fieldPosition(): Number {
    return this.apiModel.fieldPosition;
  }

  get fieldLine(): Number {
    return this.apiModel.fieldLine;
  }

  get fieldSide(): Number {
    return this.apiModel.fieldSide;
  }
}
